// Validación mejorada para números de teléfono con prefijos internacionales
export function validatePhoneNumber(value) {
  if (!value || !value.length) {
    return true;
  }

  // Configuración de validación por país
  const phoneValidation = {
    '+34': { minLength: 9, maxLength: 9, pattern: /^[0-9]{9}$/ }, // España
    '+33': { minLength: 9, maxLength: 10, pattern: /^[0-9]{9,10}$/ }, // Francia
    '+39': { minLength: 9, maxLength: 11, pattern: /^[0-9]{9,11}$/ }, // Italia
    '+49': { minLength: 10, maxLength: 12, pattern: /^[0-9]{10,12}$/ }, // Alemania
    '+351': { minLength: 9, maxLength: 9, pattern: /^[0-9]{9}$/ }, // Portugal
    '+44': { minLength: 10, maxLength: 11, pattern: /^[0-9]{10,11}$/ }, // Reino Unido
    '+1': { minLength: 10, maxLength: 10, pattern: /^[0-9]{10}$/ }, // Estados Unidos
    '+54': { minLength: 10, maxLength: 11, pattern: /^[0-9]{10,11}$/ }, // Argentina
    '+52': { minLength: 10, maxLength: 10, pattern: /^[0-9]{10}$/ }, // México
    '+57': { minLength: 10, maxLength: 10, pattern: /^[0-9]{10}$/ }, // Colombia
    '+51': { minLength: 9, maxLength: 9, pattern: /^[0-9]{9}$/ }, // Perú
    '+56': { minLength: 9, maxLength: 9, pattern: /^[0-9]{9}$/ }, // Chile
    '+55': { minLength: 10, maxLength: 11, pattern: /^[0-9]{10,11}$/ } // Brasil
  };

  // Encontrar el prefijo del país
  const foundPrefix = Object.keys(phoneValidation).find(prefix =>
    value.startsWith(prefix)
  );

  if (!foundPrefix) {
    // Si no se encuentra el prefijo, asumir formato español por defecto
    const phoneNumber = value.replace(/^\+/, '');
    return phoneNumber.match(/^[0-9]{9}$/);
  }

  // Extraer el número sin prefijo
  const phoneNumber = value.substring(foundPrefix.length);
  const validation = phoneValidation[foundPrefix];

  // Validar longitud y formato
  return validation.pattern.test(phoneNumber);
}

// Función para obtener el mensaje de error localizado
export function getPhoneValidationMessage(i18n, value) {
  const foundPrefix = ['+34', '+33', '+39', '+49', '+351', '+44', '+1', '+54', '+52', '+57', '+51', '+56', '+55']
    .find(prefix => value && value.startsWith(prefix));

  if (!foundPrefix) {
    return i18n.global.t('forms.phone');
  }

  // Mensajes específicos por país si es necesario
  const countryMessages = {
    '+34': i18n.global.t('forms.phone'),
    '+33': 'El teléfono debe contener 9-10 dígitos',
    '+39': 'El teléfono debe contener 9-11 dígitos',
    '+49': 'El teléfono debe contener 10-12 dígitos',
    '+351': 'El teléfono debe contener 9 dígitos',
    '+44': 'El teléfono debe contener 10-11 dígitos',
    '+1': 'El teléfono debe contener 10 dígitos',
    '+54': 'El teléfono debe contener 10-11 dígitos',
    '+52': 'El teléfono debe contener 10 dígitos',
    '+57': 'El teléfono debe contener 10 dígitos',
    '+51': 'El teléfono debe contener 9 dígitos',
    '+56': 'El teléfono debe contener 9 dígitos',
    '+55': 'El teléfono debe contener 10-11 dígitos'
  };

  return countryMessages[foundPrefix] || i18n.global.t('forms.phone');
}
